export const CC_API_BASE_URL = import.meta.env.VITE_CC_URL;

/** CC API Basic auth — env ile override edilebilir (VITE_CC_BASIC_AUTH) */
export const CC_BASIC_AUTHORIZATION =
  import.meta.env.VITE_CC_BASIC_AUTH ||
  "Basic QjI2QzRDMUYtRDY4RC00MUVDLTkzMjEtM0FCNDExQkUxNjk0OkQyM0M2QTEyLTk0RjMtNEIxNy04NTNBLThFODc0NThGNkNDRQ==";

export function getCcRequestConfig(extraHeaders = {}) {
  return {
    headers: {
      UserAgent: "PC",
      Authorization: CC_BASIC_AUTHORIZATION,
      "Content-Type": "application/json",
      ...extraHeaders,
    },
  };
}
